var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveChat = function SvgLiveChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 13.7,
    y1: 169.69,
    x2: 200.89,
    y2: -6.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2.66,
    y1: 157.99,
    x2: 189.86,
    y2: -18.59,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 13.7,
    y1: 169.69,
    x2: 200.89,
    y2: -6.89,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 24.73,
    y1: 181.38,
    x2: 211.93,
    y2: 4.81,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 13.7,
    y1: 169.69,
    x2: 200.89,
    y2: -6.89,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.42,58.98h-12.08c-3.96-9.41-9.85-18.09-17.32-25.33-11.74-11.38-26.93-18.79-42.78-20.87-26.27-3.45-52.01,6.61-68.87,26.91-4.84,5.83-8.77,12.35-11.68,19.29h-12.12c-9.69,0-17.58,7.89-17.58,17.58v23.44c0,9.69,7.89,17.58,17.58,17.58h24l-2.51-7.68c-7.31-22.38-3.19-45.24,11.32-62.72,14.27-17.19,36.07-25.7,58.32-22.78,27.87,3.66,50.44,25.55,54.88,53.23,3.03,18.89-2.26,37.97-14.51,52.36-12.28,14.42-30.14,22.71-49,22.74-9.74.01-17.67,7.9-17.67,17.58s7.89,17.58,17.58,17.58,17.58-7.89,17.58-17.58v-7.92c15.61-3.71,29.8-12.3,40.44-24.8,5.17-6.07,9.28-12.78,12.3-20.02h12.11c9.69,0,17.58-7.89,17.58-17.58v-23.44c0-9.69-7.89-17.58-17.58-17.58h0ZM25.81,105.86h-8.23c-3.23,0-5.86-2.63-5.86-5.86v-23.44c0-3.23,2.63-5.86,5.86-5.86h8.3c-.21.88-.4,1.76-.58,2.65-2.14,10.72-1.96,21.62.51,32.51ZM105.86,170.31c0,3.23-2.63,5.86-5.86,5.86s-5.86-2.63-5.86-5.86,2.68-5.86,5.97-5.86c1.93,0,3.85-.08,5.75-.22v6.08ZM188.28,100c0,3.23-2.63,5.86-5.86,5.86h-8.3c2.33-9.79,2.68-19.89,1.05-30.08-.27-1.7-.61-3.39-1.01-5.08h8.26c3.23,0,5.86,2.63,5.86,5.86v23.44Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7,82.42h11.72v11.72h-11.72v-11.72Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.14,82.42h11.72v11.72h-11.72v-11.72Z",
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58,82.42h11.72v11.72h-11.72v-11.72Z",
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.27,129.29v11.72h52.73c29.08,0,52.73-23.66,52.73-52.73s-23.66-52.73-52.73-52.73-52.73,23.66-52.73,52.73c0,11.85,3.98,23.31,11.26,32.57-1.41,4.94-5.92,8.44-11.26,8.44ZM100,47.26c22.62,0,41.02,18.4,41.02,41.02s-18.4,41.02-41.02,41.02h-32.43c1.68-2.91,2.72-6.16,3.04-9.56l.23-2.51-1.66-1.89c-6.57-7.48-10.19-17.09-10.19-27.06,0-22.62,18.4-41.02,41.02-41.02h0Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }));
};
export default SvgLiveChat;